import Operation from './Operation';

export default class Maximum extends Operation {
  cal (a, b) {
    // cant use vector for now
    if (a === null || a === undefined) {
      return Number(b);
    }
    a = Number(a);
    b = Number(b);
    return Math.max(a, b);
  }
}


// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Maximum.js